// extracted by mini-css-extract-plugin
export var closed = "_h4-1";
export var resizer = "_h4-0";